import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAsyncQueryResultsVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  pageSize?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  cursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetAsyncQueryResults = {
  dataLakeQuery: Pick<Types.DataLakeQuery, 'id' | 'status' | 'message'> & {
    results?: Types.Maybe<
      Pick<Types.DataLakeQueryResults, 'warningMessage' | 'tryAgain'> & {
        columnInfo: Pick<Types.DataLakeQueryResultsColumnInfo, 'order'>;
        edges: Array<Pick<Types.DataLakeQueryResultEdge, 'nodeAsString'>>;
        pageInfo: Pick<Types.DataLakeQueryResultRecordsPageInfo, 'hasNextPage' | 'endCursor'>;
        stats: Pick<Types.DataLakeQueryStats, 'bytesScanned' | 'executionTime' | 'rowCount'>;
      }
    >;
  };
};

export const GetAsyncQueryResultsDocument = gql`
  query GetAsyncQueryResults($id: ID!, $pageSize: Int, $cursor: String) {
    dataLakeQuery(id: $id) {
      id
      status
      message
      results(input: { cursor: $cursor, pageSize: $pageSize }) {
        warningMessage
        columnInfo {
          order
        }
        edges {
          nodeAsString
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        stats {
          bytesScanned
          executionTime
          rowCount
        }
        tryAgain
      }
    }
  }
`;

/**
 * __useGetAsyncQueryResults__
 *
 * To run a query within a React component, call `useGetAsyncQueryResults` and pass it any options that fit your needs.
 * When your component renders, `useGetAsyncQueryResults` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAsyncQueryResults({
 *   variables: {
 *      id: // value for 'id'
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetAsyncQueryResults(
  baseOptions: Apollo.QueryHookOptions<GetAsyncQueryResults, GetAsyncQueryResultsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAsyncQueryResults, GetAsyncQueryResultsVariables>(
    GetAsyncQueryResultsDocument,
    options,
  );
}
export function useGetAsyncQueryResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAsyncQueryResults, GetAsyncQueryResultsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAsyncQueryResults, GetAsyncQueryResultsVariables>(
    GetAsyncQueryResultsDocument,
    options,
  );
}
export function useGetAsyncQueryResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAsyncQueryResults,
    GetAsyncQueryResultsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAsyncQueryResults, GetAsyncQueryResultsVariables>(
    GetAsyncQueryResultsDocument,
    options,
  );
}
export type GetAsyncQueryResultsHookResult = ReturnType<typeof useGetAsyncQueryResults>;
export type GetAsyncQueryResultsLazyQueryHookResult = ReturnType<
  typeof useGetAsyncQueryResultsLazyQuery
>;
export type GetAsyncQueryResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetAsyncQueryResultsSuspenseQuery
>;
export type GetAsyncQueryResultsQueryResult = Apollo.QueryResult<
  GetAsyncQueryResults,
  GetAsyncQueryResultsVariables
>;
export function mockGetAsyncQueryResults({
  data,
  variables,
  errors,
}: {
  data: GetAsyncQueryResults;
  variables?: GetAsyncQueryResultsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetAsyncQueryResultsDocument, variables },
    result: { data, errors },
  };
}
